import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

import * as APIModels from '@flow/shared/src/models/Stage';
import Api from '@/api';

export interface State {
  stage: APIModels.Stage;
  startScene: string | undefined | null;
  initialized: boolean;
  userInfo: any;
}

@Module({ namespaced: true })
class Stage extends VuexModule implements State {
  stage = {
    id: '0000000000',
    name: null,
    description: null,
    published: false,
    sound: false,
    scenes: [],
    useSound: false,
  };
  startScene = null;
  initialized = false;
  userInfo = null;

  @Mutation
  private INIT({ stage, startScene, userInfo }: any) {
    this.stage = stage;
    this.initialized = true;
    this.startScene = startScene;
    this.userInfo = userInfo;
  }

  @Action({ rawError: true })
  private async init() {
    // TODO : api로 대체 필요
    console.log(
      'ffff',
      this.context.rootState.route.params,
      this.context.rootState.route.query,
    );

    const { data } = await Api.getStageInfo(
      this.context.rootState.route.params.stageId as string,
      this.context.rootState.route.query.version as string,
    );

    const userInfo = this.context.rootState.route.query['user_info'];
    const userInfoData = (() => {
      if (userInfo) {
        const decodedUserInfo = atob(userInfo);
        try {
          return JSON.parse(decodedUserInfo);
        } catch (e) {
          return {};
        }
      } else {
        return {};
      }
    })();

    // const stageId = state.route.params
    const scene = this.context.rootState.route.query.sceneId;

    this.context.commit('INIT', {
      stage: data,
      startScene: scene,
      userInfo: userInfoData,
    });

    return new Promise((resolve) => {
      resolve(this.context.state);
    });
  }
}

export default Stage;
